import { render, staticRenderFns } from "./ModalForceDelivered.vue?vue&type=template&id=25677c4a&"
import script from "./ModalForceDelivered.vue?vue&type=script&lang=js&"
export * from "./ModalForceDelivered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports